module.exports = "../dist/img/mini-32.3357.jpg";